import React from "react";

// Chakra imports
import { Flex, useColorModeValue } from "@chakra-ui/react";

// Custom components
import { HorizonLogo ,JunusLogo} from "components/icons/Icons";
import { HSeparator } from "components/separator/Separator";
import myLogo from './junus-ai-logo.png'
import myLogoWhite from './junus-ai-logo-white.png'

export function SidebarBrand() {
  //   Chakra color mode
  let logo = useColorModeValue(myLogo, myLogoWhite);

  return (
    <Flex align='center' direction='column'>
      <img height={'50'}  src={logo} style={{height:'70px',paddingBottom:'5%'}} />
      <HSeparator mb='20px' />
    </Flex>
  );
}

export default SidebarBrand;
